// @flow

/**
 * Bubble Component
 * Message bubble container with role-based styling
 */

import styled from 'styled-components';
import { breakpoints } from '../../../styles/variables';

const Bubble = styled.div`
  align-self: ${(p) => (p.$role === 'user' ? 'flex-end' : 'flex-start')};
  background: ${(p) =>
    p.$role === 'user' ? 'var(--primary)' : 'transparent'};
  color: ${(p) => (p.$role === 'user' ? 'white' : 'inherit')};
  border-radius: var(--button-border-radius);
  font-family: var(--fonts-default);
  padding: 0.5rem 0.75rem;
  width: ${(p) => (p.$role === 'agent' ? 'auto' : 'auto')};
  max-width: ${(p) => (p.$role === 'agent' ? '100%' : '80%')};
  min-width: 0;
  margin-top: 0.9rem;
  margin-left: ${(p) => (p.$role === 'agent' ? '1.5rem' : '0')};
  margin-right: ${(p) => (p.$role === 'agent' ? '1.5rem' : p.$role === 'user' ? '1.5rem' : '0')};

  @media (max-width: ${breakpoints.PHONE_SIZE}) {
    margin-top: 0.2rem;
    margin-left: ${(p) => (p.$role === 'agent' ? '0.5rem' : '0')};
    margin-right: ${(p) => (p.$role === 'agent' ? '0.5rem' : p.$role === 'user' ? '0.5rem' : '0')};
  }
`;

export default Bubble;
